import { QUEBEC } from '../constants/constants';

export const isQuebec = (province) => {
  if (province && typeof province.localeCompare === 'function') {
    return province.localeCompare(QUEBEC, 'en', { sensitivity: 'base' }) === 0;
  }
  return province === QUEBEC;
};
